// EVsContainer.js
import styles from "@/components/directory/EVsContainer.module.css";
import CarCardComponent from "@/components/ui/cards/CarCardComponent";
import CarCardSkeletonComponent from "@/components/ui/skeletons/CarCardSkeletonComponent";

const EVsContainer = ({ cars, loading }) => {
  if (loading) {
    return (
      <div className={styles.evsContainer}>
        {Array.from({ length: 10 }).map((_, index) => (
            <CarCardSkeletonComponent key={index} />
        ))}
      </div>
    );
  } else if (cars.length > 0) {
    return (
      <div className={styles.evsContainer}>
        {cars.map((car) => <CarCardComponent key={car.id} car={car} />)}
      </div>
    );
  } else {
    return <div className={styles.noResults}><span className={styles.iconResults}>🪫</span> No EVs found...</div>;
  }
};

export default EVsContainer;
